import React, { useEffect } from "react";
import classes from "./CatDropList.module.css";
import {
  getAllChildCategories,
  getAllNullParentCategories,
  getAllParentCategories,
} from "../../../../services/categories";
import useHttp from "../../../../hooks/use-http";
import CatMenuItems from "./CatMenuItems";

// const category = [
//   {
//     categoryId: 1,
//     title: "Electronic Accessories",
//     submenu: [
//       {
//         categoryId: 11,
//         title: "Mobile Accessories",
//         submenu: [
//           {
//             categoryId: 11,
//             title: "Mobile Accessories",
//             submenu: [
//               {
//                 categoryId: 11,
//                 title: "Mobile Accessories",
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   { categoryId: 2, title: "Electronic Device" },
//   { categoryId: 3, title: "Groceries" },
//   {
//     categoryId: 4,
//     title: "TV & Home Appliances",
//     submenu: [
//       {
//         categoryId: 11,
//         title: "Mobile Accessories",
//         submenu: [
//           {
//             categoryId: 11,
//             title: "Mobile Accessories",
//             submenu: [
//               {
//                 categoryId: 11,
//                 title: "Mobile Accessories",
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   { categoryId: 5, title: "Men's Fashion & Accessories" },
// ];

const CatDropItem = (props) => {
  // const [parentId, setParentId] = useState();

  const {
    sendRequest,
    status,
    data: productParentCategories,
  } = useHttp(getAllNullParentCategories, true);

  const {
    sendRequest: productChildSendRequest,
    status: productChildCategoriesStatus,
    data: productChildCategories,
  } = useHttp(getAllChildCategories, true);

  useEffect(() => {
    sendRequest();
  }, [sendRequest]);

  // for (const key in data) {
  //   const quoteObj = {
  //     id: key,
  //     ...data[key],
  //   };

  // productParentCategories.forEach((element) => {
  //   transformedMenu.push(quoteObj);
  // });

  // transformedQuotes.push(quoteObj);
  // }
  // let content;

  if (status === "completed" && productParentCategories) {
    const transformedMenu = [];

    for (let i = 0; i < productParentCategories.length; i++) {
      const menuObj = {
        categoryId: productParentCategories[i].categoryId,
        title: productParentCategories[i].title,
      };

      transformedMenu.push(menuObj);
    }

    // console.log(transformedMenu);

    // productParentCategories.map((prodcat) => (
    // <li key={prodcat.categoryId}>
    //   <Link
    //     to={`/category/${prodcat.title?.split(" ").join("-").toLowerCase()}`}
    //   >
    //     {prodcat.title}
    //   </Link>
    // </li>
    // <li key={prodcat.categoryId} className={classes["breadcrumb_item"]}>
    //   <span className={classes["breadcrumb_item_text"]}>
    //     <Link
    //       to={`/category/${prodcat.title
    //         ?.split(" ")
    //         .join("-")
    //         .toLowerCase()}`}
    //       title={prodcat.title}
    //       className={classes["breadcrumb_item_anchor"]}
    //     >
    //       <span>{prodcat.title}</span>
    //     </Link>
    //   </span>
    //   <ion-icon data_nmi="arrow_ico" name="chevron-forward-outline" />
    // </li>
    // ));
  }

  return (
    <div style={{ position: "relative", height:"100%" }}>
      <ul className={`${classes["nav_menu-dropdown"]} ${classes.root_menu}`}>
        {props.fetchData.slice(0,12).map((catitems, index) => {
          let depthLevel = 1;
          return (
            <CatMenuItems items={catitems} key={index} depth={depthLevel} />
          );
        })}
      </ul>
    </div>
  );
};

export default CatDropItem;
